import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { normalizeInputValue } from 'localmed-core';

import { widgetSettingsShape } from '../WidgetSettings';
import SuggestedInsuranceIssuersMenu from './SuggestedInsuranceIssuersMenu';
import InsuranceIssuerSelectOption from './InsuranceIssuerSelectOption';

export default class PartnerInsuranceIssuerSelect extends Component {
  static propTypes = {
    initialSelectedValue: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    selectedItem: PropTypes.object,
    onChange: PropTypes.func,
    emptyLabel: PropTypes.string,
    widgetSettings: widgetSettingsShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.triggerOnChangeFromDefaultSelectedValue(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.triggerOnChangeFromDefaultSelectedValue(props);
  }

  getPartnerInsuranceIssuers(
    {
      widgetSettings: {
        partnerData: { partner },
      },
    } = this.props
  ) {
    return (partner && partner.insuranceIssuers.nodes) || [];
  }

  triggerOnChangeFromDefaultSelectedValue({
    selectedItem,
    initialSelectedValue,
    onChange,
    ...props
  }) {
    if (selectedItem != null || initialSelectedValue == null || onChange == null) {
      return;
    }
    selectedItem = this.getPartnerInsuranceIssuers(props).find(
      (partnerIssuer) => partnerIssuer.insuranceIssuer.id === initialSelectedValue
    );
    if (selectedItem) {
      onChange(selectedItem.insuranceIssuer);
    }
  }

  renderMenu = (comboboxProps) => {
    if (this.props.widgetSettings.partnerData.loading) {
      return [];
    }
    const { selectedItem, toLabel } = comboboxProps;
    let { inputValue } = comboboxProps;
    inputValue = normalizeInputValue(inputValue);
    if (inputValue === '' || normalizeInputValue(toLabel(selectedItem)) === inputValue) {
      return this.renderFeaturedIssuers(comboboxProps);
    }
    return this.renderSearchResults({ ...comboboxProps, inputValue });
  };

  renderFeaturedIssuers(comboboxProps) {
    const { ComboboxMessage, ComboboxSectionTitle, ComboboxOption } = this.props;
    const partnerIssuers = this.getPartnerInsuranceIssuers();
    const featuredIssuers = partnerIssuers
      .filter((partnerIssuer) => partnerIssuer.isFeatured)
      .map((partnerIssuer) => partnerIssuer.insuranceIssuer);
    const allIssuers = partnerIssuers
      .filter((partnerIssuer) => !partnerIssuer.isFeatured)
      .map((partnerIssuer) => partnerIssuer.insuranceIssuer);
    return (
      <SuggestedInsuranceIssuersMenu
        emptyLabel={this.props.emptyLabel}
        featuredInsuranceIssuers={featuredIssuers}
        allInsuranceIssuers={allIssuers}
        comboboxProps={comboboxProps}
        ComboboxMessage={ComboboxMessage}
        ComboboxSectionTitle={ComboboxSectionTitle}
        ComboboxOption={ComboboxOption}
      />
    );
  }

  renderSearchResults(comboboxProps) {
    const { ComboboxOption } = this.props;

    let partnerIssuers = this.getPartnerInsuranceIssuers();
    const { inputValue, toLabel } = comboboxProps;
    partnerIssuers = partnerIssuers.filter(
      ({ insuranceIssuer }) =>
        normalizeInputValue(toLabel(insuranceIssuer)).indexOf(inputValue) !== -1
    );
    return partnerIssuers.map(({ insuranceIssuer }, index) => (
      <InsuranceIssuerSelectOption
        key={insuranceIssuer.id}
        item={insuranceIssuer}
        index={index}
        ComboboxOption={ComboboxOption}
        {...comboboxProps}
      />
    ));
  }

  render() {
    const { Combobox } = this.props;
    return (
      <Combobox loading={this.props.widgetSettings.partnerData.loading} {...this.props}>
        {this.renderMenu}
      </Combobox>
    );
  }
}
